// Solve budget = gross + employer tax + pension + pension tax.
// Rounding remains the responsibility of the existing calculation flow.
export function isPensionWithinLimit(pension: number, grossSalary: number, pensionFactor: number): boolean {
  if (!Number.isFinite(pension) || pension < 0 || !Number.isFinite(pensionFactor) ||
    pensionFactor < 0 || pensionFactor > 0.10) {
    return false;
  }
  if (pension === 0) {
    return true;
  }
  // Compare whole-krona amounts without changing the salary calculation's rounding.
  return Number.isFinite(grossSalary) && grossSalary > 0 && pension <= Math.round(grossSalary * 0.10);
}

export function calculatePension(salaryBudget: number, pensionFactor: number,
  pensionTaxFactor: number, employerTaxRate: number, normalTaxRate: number | null = null,
  remainingReducedGrossSalary: number = 0): number {
  if (salaryBudget <= 0 || pensionFactor <= 0) {
    return 0;
  }

  const pensionCostFactor = pensionFactor * (1 + pensionTaxFactor);
  const reducedCostFactor = 1 + employerTaxRate + pensionCostFactor;
  let grossSalary = salaryBudget / reducedCostFactor;

  if (normalTaxRate != null) {
    const reducedGrossSalary = Math.max(0, remainingReducedGrossSalary);
    const reducedCostLimit = reducedGrossSalary * reducedCostFactor;
    if (salaryBudget > reducedCostLimit) {
      grossSalary = reducedGrossSalary + (salaryBudget - reducedCostLimit) /
        (1 + normalTaxRate + pensionCostFactor);
    }
  }

  return grossSalary * pensionFactor;
}
